module.exports = __webpack_public_path__ + "img/nook-sage.662920f8.webp";